import { useRef, } from 'react';

export const useFocus = () => {
  const htmlElRef = useRef<HTMLInputElement>(null);
  const setFocus: any = (e: any) => htmlElRef.current?.focus?.();

  return [ htmlElRef, setFocus, ];
};
